import { UiIconName } from "./uiIcons";

// Natures de pièce justificative acceptées (facultative) — même liste que
// VERIFICATION_DOC_TYPES dans OLTODO-backend/src/routes/users.ts. Copié à l'identique dans
// OLTODO/utils/verificationDocs.ts.
export const VERIFICATION_DOC_TYPES: { key: string; icon: UiIconName; i18nKey: string }[] = [
  { key: "id_card", icon: "idCard", i18nKey: "vfy_doc_type_id_card" },
  { key: "passport", icon: "passport", i18nKey: "vfy_doc_type_passport" },
  { key: "driver_license", icon: "steering", i18nKey: "vfy_doc_type_driver_license" },
  { key: "utility_bill", icon: "receipt", i18nKey: "vfy_doc_type_utility_bill" },
  { key: "transit_pass", icon: "ticket", i18nKey: "vfy_doc_type_transit_pass" },
  { key: "other", icon: "file", i18nKey: "vfy_doc_type_other" },
];

export const docTypeI18nKey = (key?: string | null) => VERIFICATION_DOC_TYPES.find(d => d.key === key)?.i18nKey || "vfy_doc_type_other";
